import styled from "styled-components";
import { PageTitle } from "../modules/PageHeaders";
import BorderedCard from "./modules/BorderedCard";
import {
  TableCompData,
  ModalCompAdvanceUpdate,
  ButtonComp,
} from "../../../components";
import { CommunicationGroupListHeader } from "../../../utils/TableHeader";
import EmptyTable from "../../../components/Common/EmptyTable";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";
import { useState, useMemo } from "react";
import GroupForm from "./modules/GroupForm";
import { useCommunicationActions } from "./useCommunicationActions";
import { useGetGroupsNamesQuery } from "../../../store/admin/communicationSlice";
import { useNavigate, useLocation } from "react-router-dom";
import TablePagination from "../../../components/Table/Pagination";

export const GroupManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalName, setModalName] = useState();
  const [initialGroupName, setInitialGroupName] = useState("");
  const [groupId, setGroupId] = useState(null);
  const { addGroup, editGroup } = useCommunicationActions();
  const [pageNumber, setPageNumber] = useState(1);
  const { data: groupsData = {}, isLoading } =
    useGetGroupsNamesQuery(pageNumber);
  const { groups, pagination } = useMemo(() => {
    const { pagination = {}, communication_groups = [] } = groupsData;
    const perPage = pagination.perPage || 5;
    const items = communication_groups.map((item, index) => ({
      ...item,
      serialNumber: index + 1 + (pageNumber - 1) * perPage,
      totalMembers: item?.members.length,
    }));
    return {
      groups: items,
      pagination: pagination,
    };
  }, [groupsData, pageNumber]);
  const createGroup = (groupName) => {
    setModalName();
    addGroup(groupName);
  };
  const updateGroupName = (newGroupName) => {
    setModalName();
    editGroup({ id: groupId, name: newGroupName });
  };
  const modalItems = [
    {
      name: "Create Group",
      component: (
        <GroupForm
          onBack={() => setModalName()}
          title={"Create New Group"}
          onProceed={createGroup}
        />
      ),
    },
    {
      name: "Edit Group",
      component: (
        <GroupForm
          onBack={() => setModalName()}
          title={"Edit Group Name"}
          onProceed={updateGroupName}
          initialValue={initialGroupName}
          submitText="Update group name"
        />
      ),
    },
  ];

  const TableDropDown = [
    {
      name: "View",
      action: (data) => {
        navigate(`${location.pathname}/${data?.id}?name=${data?.name}`);
      },
    },
    {
      name: "Edit",
      action: (data) => {
        setModalName("Edit Group");
        setGroupId(data?.id);
        setInitialGroupName(data?.name);
      },
    },
  ];

  return (
    <>
      <Wrapper className="mx-2 mx-lg-4">
        <PageTitle title={"Group Management"} />
        <BorderedCard
          title={"About Communication Groups"}
          content={
            "Create and manage communication groups to organize members for targeted messaging. Groups allow you to send SMS and email campaigns to specific member segments, making your communications more effective and personalized."
          }
        />
        <div className="mb-4"></div>
        <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-4">
          <h5 className="fw-bold mb-0" style={{ fontSize: "18px", color: "#383838" }}>
            Group List
          </h5>
          <ButtonComp
            btnClassName={"px-4 py-2 text-white rounded"}
            btnText={"Create a new group"}
            onClick={() => setModalName("Create Group")}
            ButtonInlineStyle={{
              backgroundColor: "var(--color-primary)",
              borderRadius: "10px",
              border: "none",
              minWidth: "200px",
            }}
          />
        </div>
        <TableCompData
          columns={CommunicationGroupListHeader(TableDropDown)}
          data={groups}
          marginBottom={"5rem"}
          progressPending={isLoading}
          progressComponent={<TableSkeletonLoader rows={10} columns={4} />}
          message={
            !isLoading && (
              <EmptyTable
                Message={
                  "Group lists is empty, your created groups will appear here"
                }
                btnText={"Create Group"}
                onClick={() => setModalName("Create Group")}
              />
            )
          }
        />
        {!isLoading && groups.length > 0 && (
          <TablePagination {...pagination} handlePageChange={setPageNumber} />
        )}
        <ModalCompAdvanceUpdate
          centered={true}
          arrayComp={modalItems}
          pageName={modalName}
        />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  .modal-content {
    border-radius: 30px;
  }

  button:hover {
    background-color: color-mix(in srgb, var(--color-primary) 80%, black) !important;
    transition: background-color 0.3s ease;
  }
`;

export default GroupManagement;
